import { render, staticRenderFns } from "./EducationalModelBlock.vue?vue&type=template&id=6b8a17c2&scoped=true"
import script from "./EducationalModelBlock.vue?vue&type=script&lang=js"
export * from "./EducationalModelBlock.vue?vue&type=script&lang=js"
import style0 from "./EducationalModelBlock.vue?vue&type=style&index=0&id=6b8a17c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a17c2",
  null
  
)

export default component.exports